define(["require", "exports", "jquery", "knockout", "log", "./dateUtils"], function (require, exports, $, ko, log, dateUtils) {
    "use strict";
    var Tools = /** @class */ (function () {
        function Tools() {
        }
        Tools.loadAndBindDialog = function (_a) {
            var template = _a.template, url = _a.url, _b = _a.urlParam, urlParam = _b === void 0 ? {} : _b, model = _a.model, modelType = _a.modelType, modelName = _a.modelName, root = _a.root;
            return function (modal) {
                //alert("Opened!");
                var getModelCall = Tools.ajaxGet({
                    url: url,
                    data: urlParam,
                    success: function (result) {
                        if (result.Success) {
                            model(new modelType(result.Data));
                        }
                        else {
                            log.error(result.Error);
                        }
                    }
                });
                $.when(getModelCall).done(function (data) {
                    //alert("Done Updating!");
                    console.log(root);
                    $(modal).find(".modal-body")
                        .html("<div data-bind=\"template: { name: '".concat(template, "', data: $root }\"></div>"));
                    ko.applyBindings(data.Data, modal);
                    //alert("Opened ran");
                });
            };
        };
        Tools.ajaxLoading = function () {
        };
        Tools.closeAjaxLoading = function () {
        };
        Tools.ajaxJsonGet = function (options) {
            var jsonOptions = {
                type: "GET",
                contentType: "application/json",
                dataType: "json"
            };
            Tools.ajaxGet($.extend(options, jsonOptions));
        };
        ;
        Tools.ajaxGet = function (options) {
            var defaults = {
                type: "GET",
                error: function (e) {
                    /*if (e.status && e.status !== 0) {
                        console.error(e.statusText);
                    }*/
                    console.log(e);
                },
                traditional: true
            };
            return $.ajax($.extend(defaults, options));
        };
        ;
        Tools.ajaxJsonPost = function (options) {
            var jsonOptions = {
                type: "POST",
                contentType: "application/json",
                dataType: "json"
            };
            return Tools.ajaxPost($.extend(options, jsonOptions));
        };
        ;
        Tools.ajaxPost = function (options) {
            var defaults = {
                type: "POST",
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                error: function (jqXHR) {
                    /*if (jqXHR.status && jqXHR.status !== 0) {
                        console.error(jqXHR.statusText);
                    }*/
                    console.error("Ajax error:", jqXHR);
                },
                traditional: true
            };
            return $.ajax($.extend(defaults, options));
        };
        ;
        Tools.getRandomInt = function () {
            return Math.floor(Math.random() * (-1000000));
        };
        Tools.getBrowserInfo = function () {
            var i = 0, iOS = false, iDevice = ["iPad", "iPhone", "iPod"];
            for (; i < iDevice.length; i++) {
                if (navigator.platform === iDevice[i]) {
                    iOS = true;
                    break;
                }
            }
            return {
                iOS: iOS,
                language: navigator.language
            };
        };
        Tools.success = function (message) {
            var notifyObject = $("div#message").data("kendoNotification");
            notifyObject.setOptions({
                hideOnClick: true,
                autoHideAfter: 3000,
                button: false
            });
            notifyObject.show(message, "success");
        };
        Tools.error = function (message) {
            var notifyObject = $("div#message").data("kendoNotification");
            notifyObject.setOptions({
                hideOnClick: false,
                autoHideAfter: 10000,
                button: true
            });
            notifyObject.show(message, "error");
        };
        Tools.ajaxFailed = function (result) {
            if (result.status && result.status !== 0) {
                alert("Error! " + result.status + " " + result.statusText);
            }
        };
        Tools.urlify = function (text) {
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function (url) {
                return '<a target="_blank" href="' + url + '">' + url + "</a>";
            });
        };
        Tools.objectToJSON = function (obj) {
            var replacer = function (key, value) {
                var val = this[key];
                if (dateUtils.isDate(val)) {
                    return dateUtils.toIsoString(val);
                }
                return value;
            };
            return JSON.stringify(obj, replacer);
        };
        Tools.modelToJSON = function (model) {
            var modelMapping = {};
            if (typeof model === "function") {
                modelMapping = model().constructor.Mapping || {};
            }
            else {
                modelMapping = model.constructor.Mapping || {};
            }
            return Tools.objectToJSON(ko.mapping.toJS(model, modelMapping));
        };
        Tools.modelToFormData = function (model) {
            var objModel = ko.mapping.toJS(model);
            for (var key in objModel) {
                // skip loop if the property is from prototype
                if (!objModel.hasOwnProperty(key))
                    continue;
                var value = objModel[key];
                if (dateUtils.isDate(value)) {
                    objModel[key] = dateUtils.toIsoString(value);
                }
            }
            return objModel;
        };
        Tools.escapeHtml = function (text) {
            return text
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        };
        Tools.stripHtml = function (html) {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        };
        Tools.alertModal = function (options) {
            var defaultOptions = {
                backdrop: "static",
                keyboard: false
            };
            var modalOptions = $.extend({}, defaultOptions, options.modalOptions);
            var id = "modal" + new Date().getTime();
            var modalSource = $("#alertModal").clone();
            modalSource.attr("id", id);
            var modalWindow = modalSource.on("show.bs.modal", function (event) {
                var modal = $(this);
                modal.find(".modal-header").addClass(options.headerClass);
                modal.find(".modal-title").text(options.title);
                modal.find(".modal-body h3").text(options.text);
                if (options.html) {
                    modal.find(".modal-body h3").html(options.html);
                }
                var confirmButton = modal.find(".btn-default");
                confirmButton.text(options.buttonTitle || "Confirm");
                if (options.open) {
                    options.open(this);
                }
            }).on("shown.bs.modal", function (event) {
                modalSource.draggable({
                    handle: ".modal-header",
                    cancel: ".modal-title"
                });
            }).modal(modalOptions);
            return modalWindow;
        };
        Tools.confirmModal = function (options, confirmCallback) {
            var defaultOptions = {
                backdrop: "static",
                keyboard: false
            };
            var modalOptions = $.extend({}, defaultOptions, options.modalOptions);
            var modalWindow = $("#confirmModal").on("show.bs.modal", function (event) {
                var modal = $(this);
                modal.find(".modal-title").text(options.title);
                modal.find(".modal-body h3").text(options.text);
                if (options.html) {
                    modal.find(".modal-body h3").html(options.html);
                }
                var confirmButton = modal.find(".btn-confirm");
                confirmButton.text(options.buttonTitle || "Confirm");
                confirmButton.unbind("click");
                confirmButton.click(function () {
                    confirmCallback(modal);
                });
                confirmButton.removeClass("btn-danger");
                confirmButton.removeClass("btn-warning");
                if (options.type === "danger") {
                    confirmButton.addClass("btn-danger");
                }
                else if (options.type === "warning") {
                    confirmButton.addClass("btn-warning");
                }
            }).on("shown.bs.modal", function (event) {
                $(this).draggable({
                    handle: ".modal-header",
                    cancel: ".modal-title"
                });
            }).modal(modalOptions);
            return modalWindow;
        };
        Tools.editModal = function (options) {
            var defaultOptions = {
                keyboard: false,
                backdrop: "static"
            };
            var modalOptions = $.extend({}, defaultOptions, options.modalOptions);
            var id = "modal" + new Date().getTime();
            var modalSource = $("#editModal").clone();
            modalSource.attr("id", id);
            var resizeWorker = 0;
            var resizeHandler = function () {
                if (resizeWorker) {
                    clearTimeout(resizeWorker);
                }
                resizeWorker = setTimeout(function () {
                    log.log("resize modal");
                    var newHeight = Tools.resizeModal(modalSource);
                    if (options.onResize) {
                        options.onResize(newHeight);
                    }
                }, 100);
            };
            var modalWindow = modalSource.on("show.bs.modal", function (e) {
                var modal = $(this);
                modal.find(".modal-title").text(options.title);
                modal.find(".modal-body").html("<div style=\"background: url('/Content/images/loading.gif') no-repeat 50% 50%; width: 100%; height: 50px;\" ></div>");
                if (options.modalClass) {
                    modal.find(".modal-dialog").addClass(options.modalClass);
                }
                var cancelButton = modal.find(".btn-close");
                cancelButton.text(options.cancelButtonTitle || "Cancel");
                cancelButton.unbind("click");
                if (options.cancel) {
                    options.cancel.bind(modal);
                    cancelButton.click(function (event) {
                        options.cancel(event, modal);
                    });
                }
                var confirmButton = modal.find(".btn-save");
                confirmButton.unbind("click");
                options.save.bind(modal);
                confirmButton.click(function (event) {
                    var focusedElement = $(':focus');
                    if (focusedElement) {
                        focusedElement.blur();
                    }
                    options.save(event, modal);
                });
                confirmButton.text(options.buttonTitle || "Save");
                if (options.buttonTitle === "Delete") {
                    confirmButton.data("loading-text", "Deleting...");
                }
                if (options.loadingText) {
                    confirmButton.data("loading-text", options.loadingText);
                }
                if (options.type === "danger") {
                    confirmButton.addClass("btn-danger");
                }
                else if (options.type === "info") {
                    confirmButton.addClass("btn-info");
                }
                if (options.hideFooter) {
                    $(".modal-footer", modal).hide();
                }
                if (options.open) {
                    options.open(this);
                }
            }).on("hidden.bs.modal", function (e) {
                ko.cleanNode(this);
                $(this).find(".modal-body").children().filter("audio").each(function () {
                    this.pause(); // can't hurt
                    //delete this; // @sparkey reports that this did the trick (even though it makes no sense!)
                    $(this).remove(); // this is probably what actually does the trick
                });
                $(this).find(".modal-body").children().filter("video").each(function () {
                    this.pause(); // can't hurt
                    //delete this as any; // @sparkey reports that this did the trick (even though it makes no sense!)
                    $(this).remove(); // this is probably what actually does the trick
                });
                $(this).find(".modal-body").empty();
                $(this).find(".modal-dialog").removeClass(options.modalClass);
                $("#" + id).remove();
                if (options.close) {
                    options.close(this);
                }
                $(window).off("resize", resizeHandler);
            }).on("shown.bs.modal", function (event) {
                if (options.opened) {
                    options.opened(this);
                }
                $(window).resize(resizeHandler);
                var MutationObserver = window["MutationObserver"] || window["WebKitMutationObserver"];
                if (MutationObserver) {
                    var obs = new MutationObserver(function (mutations, observer) {
                        // look through all mutations that just occured
                        console.log("bar was added!");
                        resizeHandler();
                    });
                    obs.observe(modalSource.get(0), {
                        childList: true,
                        subtree: true
                    });
                }
                modalSource.draggable({
                    handle: ".modal-header,.modal-footer",
                    cancel: ".modal-title"
                });
                var resizeClassAdded = false;
                $(".modal-content", modalSource).css("width", "100%");
                $(".modal-content", modalSource).css("height", "100%");
                $(".modal-dialog", modalSource).resizable({
                    minHeight: 200,
                    minWidth: 300,
                    resize: function () {
                        if (!resizeClassAdded) {
                            $(".modal-footer", modalSource).addClass("resizable");
                            $(".modal-body", modalSource).addClass("resizable");
                            resizeClassAdded = true;
                        }
                    }
                });
            }).modal(modalOptions);
            return modalWindow;
        };
        Tools.resizeModal = function (modalSource) {
            var dialog = $(".modal-dialog", modalSource);
            var body = $(".modal-content", modalSource);
            var bodyheight = parseInt(body.css("height"));
            var modalheight = parseInt(modalSource.css("height"));
            var bodymargins = parseInt(dialog.css("margin-top")) + parseInt(dialog.css("margin-bottom"));
            var height = modalheight + bodymargins;
            var windowHeight = $(window).height();
            var maxHeight = windowHeight - bodymargins;
            if (bodyheight <= height) {
                height = bodyheight + bodymargins;
            }
            log.log("content: ".concat(bodyheight, " other: ").concat(height));
            if (windowHeight <= height) {
                height = windowHeight - bodymargins;
                $(".modal-dialog", modalSource).css("height", height + "px");
                //$(".modal-content", modalSource).css("height", height + "px");
                $(".modal-footer", modalSource).addClass("resizable");
                $(".modal-body", modalSource).addClass("resizable");
            }
            $(".modal-dialog", modalSource).css("max-height", maxHeight + "px");
            return bodyheight;
        };
        Tools.onElementHeightChange = function (elm, callback) {
            var lastHeight = elm.clientHeight, newHeight;
            var run = function () {
                newHeight = elm.clientHeight;
                if (lastHeight !== newHeight)
                    callback(elm);
                lastHeight = newHeight;
                if (elm.onElementHeightChangeTimer)
                    clearTimeout(elm.onElementHeightChangeTimer);
                elm.onElementHeightChangeTimer = setTimeout(run, 200);
            };
        };
        Tools.initMenuActions = function (selector, controller) {
            $(selector).on("click", function (e) {
                var actionName = $(e.target).data("action");
                var actionData = $(e.target).data("actiondata");
                if (actionName) {
                    controller[actionName](actionData);
                    e.preventDefault();
                }
            });
        };
        Tools.isOnScreen = function (viewport, elem, topOffset) {
            if (topOffset === void 0) { topOffset = 0; }
            var viewPortBounds = viewport.getBoundingClientRect();
            var viewport_top = viewPortBounds.top + topOffset;
            var viewport_height = viewPortBounds.height;
            var viewport_bottom = viewPortBounds.bottom;
            var $elem = $(elem);
            var top = $elem.offset().top;
            var height = $elem.height();
            var bottom = top + height;
            return (top >= viewport_top && top < viewport_bottom) ||
                (bottom > viewport_top && bottom <= viewport_bottom) ||
                (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom);
        };
        Tools.isOnScreenTopTop = function (viewport, elem, topOffset) {
            if (topOffset === void 0) { topOffset = 0; }
            var viewPortBounds = viewport.getBoundingClientRect();
            var viewport_top = viewPortBounds.top + topOffset;
            var viewport_height = viewPortBounds.height;
            var viewport_bottom = viewPortBounds.bottom;
            var $elem = $(elem);
            var top = $elem.offset().top;
            var height = $elem.height();
            var bottom = top + height;
            return top >= viewport_top;
        };
        Tools.isOnScreenBottomTop = function (viewport, elem, topOffset) {
            if (topOffset === void 0) { topOffset = 0; }
            var viewPortBounds = viewport.getBoundingClientRect();
            var viewport_top = viewPortBounds.top + topOffset;
            var viewport_height = viewPortBounds.height;
            var viewport_bottom = viewPortBounds.bottom;
            var $elem = $(elem);
            var top = $elem.offset().top;
            var height = $elem.height();
            var bottom = top + height;
            return bottom >= viewport_top;
        };
        Tools.isValidEmail = function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        };
        Tools.isValidPassword = function (password) {
            var allErrors = [];
            if (password.length < 6) {
                allErrors.push("The password must be at least 6 characters.");
            }
            if (!password.match(/[A-Z]/g)) {
                allErrors.push("Passwords must have at least one uppercase ('A'-'Z').");
            }
            if (!password.match(/[0-9]/g)) {
                allErrors.push("Passwords must have at least one digit ('0'-'9').");
            }
            if (/^[a-zA-Z0-9]+$/.test(password)) {
                allErrors.push("Passwords must have at least one non alphanumeric character.");
            }
            if (allErrors.length > 0) {
                Tools.error(allErrors.join("<br/>"));
                return false;
            }
            return true;
        };
        Tools.validatePassword = function (password) {
            var allErrors = [];
            if (password.length < 6) {
                allErrors.push("* The password must be at least 6 characters.");
            }
            if (!password.match(/[A-Z]/g)) {
                allErrors.push("* Passwords must have at least one uppercase ('A'-'Z').");
            }
            if (!password.match(/[0-9]/g)) {
                allErrors.push("* Passwords must have at least one digit ('0'-'9').");
            }
            if (/^[a-zA-Z0-9]+$/.test(password)) {
                allErrors.push("* Passwords must have at least one non alphanumeric character.");
            }
            if (allErrors.length > 0) {
                return allErrors.join("<br/>");
            }
            return null;
        };
        Tools.validateCNam = function (cnam) {
            var allErrors = [];
            if (!cnam) {
                return null;
            }
            if (cnam.length > 15) {
                allErrors.push("CNAM Storage name exceeded length limit, max length is 15 symbols");
            }
            var regexBadEncoding = /[^\x00-\xFF]/;
            var regexSpecialChars = /^\*|^\s|[\x00-\x1F\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F\x80-\xFF]/;
            var regexAlfaChars = /[A-Za-z]/;
            if (regexBadEncoding.test(cnam)) {
                allErrors.push("Bad Encoding");
            }
            if (regexSpecialChars.test(cnam)) {
                allErrors.push("Make sure CNAM Storage Name do not begin with a space or an asterik(*) and does not contain any invalid special characters");
            }
            if (!regexAlfaChars.test(cnam)) {
                allErrors.push("CNAM Storage Name must contain at least one alpha character");
            }
            if (allErrors.length > 0) {
                return allErrors.join("<br/>");
            }
            return null;
        };
        Tools.string2ArrayBuffer = function (s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i !== s.length; ++i) {
                view[i] = s.charCodeAt(i) & 0xFF;
            }
            return buf;
        };
        Tools.getMonth = function () {
            var monthsJson = [
                { "name": "January", "value": "1" },
                { "name": "February", "value": "2" },
                { "name": "March", "value": "3" },
                { "name": "April", "value": "4" },
                { "name": "May", "value": "5" },
                { "name": "June", "value": "6" },
                { "name": "July", "value": "7" },
                { "name": "August", "value": "8" },
                { "name": "September", "value": "9" },
                { "name": "October", "value": "10" },
                { "name": "November", "value": "11" },
                { "name": "December", "value": "12" }
            ];
            return monthsJson;
        };
        Tools.getStates = function () {
            var statesJson = [
                { "name": "Alabama", "value": "AL" },
                { "name": "Alaska", "value": "AK" },
                { "name": "Arizona", "value": "AZ" },
                { "name": "Arkansas", "value": "AR" },
                { "name": "California", "value": "CA" },
                { "name": "Colorado", "value": "CO" },
                { "name": "Connecticut", "value": "CT" },
                { "name": "Delaware", "value": "DE" },
                { "name": "District of Columbia", "value": "DC" },
                { "name": "Florida", "value": "FL" },
                { "name": "Georgia", "value": "GA" },
                { "name": "Hawaii", "value": "HI" },
                { "name": "Idaho", "value": "ID" },
                { "name": "Illinois", "value": "IL" },
                { "name": "Indiana", "value": "IN" },
                { "name": "Iowa", "value": "IA" },
                { "name": "Kansa", "value": "KS" },
                { "name": "Kentucky", "value": "KY" },
                { "name": "Lousiana", "value": "LA" },
                { "name": "Maine", "value": "ME" },
                { "name": "Maryland", "value": "MD" },
                { "name": "Massachusetts", "value": "MA" },
                { "name": "Michigan", "value": "MI" },
                { "name": "Minnesota", "value": "MN" },
                { "name": "Mississippi", "value": "MS" },
                { "name": "Missouri", "value": "MO" },
                { "name": "Montana", "value": "MT" },
                { "name": "Nebraska", "value": "NE" },
                { "name": "Nevada", "value": "NV" },
                { "name": "New Hampshire", "value": "NH" },
                { "name": "New Jersey", "value": "NJ" },
                { "name": "New Mexico", "value": "NM" },
                { "name": "New York", "value": "NY" },
                { "name": "North Carolina", "value": "NC" },
                { "name": "North Dakota", "value": "ND" },
                { "name": "Ohio", "value": "OH" },
                { "name": "Oklahoma", "value": "OK" },
                { "name": "Oregon", "value": "OR" },
                { "name": "Pennsylvania", "value": "PA" },
                { "name": "Rhode Island", "value": "RI" },
                { "name": "South Carolina", "value": "SC" },
                { "name": "South Dakota", "value": "SD" },
                { "name": "Tennessee", "value": "TN" },
                { "name": "Texas", "value": "TX" },
                { "name": "Utah", "value": "UT" },
                { "name": "Vermont", "value": "VT" },
                { "name": "Virginia", "value": "VA" },
                { "name": "Washington", "value": "WA" },
                { "name": "West Virginia", "value": "WV" },
                { "name": "Wisconsin", "value": "WI" },
                { "name": "Wyoming", "value": "WY" }
            ];
            return statesJson;
        };
        Tools.getCountries = function () {
            var countriesJson = [
                { "name": "Afghanistan", "value": "AF" },
                { "name": "�land Islands", "value": "AX" },
                { "name": "Albania", "value": "AL" },
                { "name": "Algeria", "value": "DZ" },
                { "name": "American Samoa", "value": "AS" },
                { "name": "AndorrA", "value": "AD" },
                { "name": "Angola", "value": "AO" },
                { "name": "Anguilla", "value": "AI" },
                { "name": "Antarctica", "value": "AQ" },
                { "name": "Antigua and Barbuda", "value": "AG" },
                { "name": "Argentina", "value": "AR" },
                { "name": "Armenia", "value": "AM" },
                { "name": "Aruba", "value": "AW" },
                { "name": "Australia", "value": "AU" },
                { "name": "Austria", "value": "AT" },
                { "name": "Azerbaijan", "value": "AZ" },
                { "name": "Bahamas", "value": "BS" },
                { "name": "Bahrain", "value": "BH" },
                { "name": "Bangladesh", "value": "BD" },
                { "name": "Barbados", "value": "BB" },
                { "name": "Belarus", "value": "BY" },
                { "name": "Belgium", "value": "BE" },
                { "name": "Belize", "value": "BZ" },
                { "name": "Benin", "value": "BJ" },
                { "name": "Bermuda", "value": "BM" },
                { "name": "Bhutan", "value": "BT" },
                { "name": "Bolivia", "value": "BO" },
                { "name": "Bosnia and Herzegovina", "value": "BA" },
                { "name": "Botswana", "value": "BW" },
                { "name": "Bouvet Island", "value": "BV" },
                { "name": "Brazil", "value": "BR" },
                { "name": "British Indian Ocean Territory", "value": "IO" },
                { "name": "Brunei Darussalam", "value": "BN" },
                { "name": "Bulgaria", "value": "BG" },
                { "name": "Burkina Faso", "value": "BF" },
                { "name": "Burundi", "value": "BI" },
                { "name": "Cambodia", "value": "KH" },
                { "name": "Cameroon", "value": "CM" },
                { "name": "Canada", "value": "CA" },
                { "name": "Cape Verde", "value": "CV" },
                { "name": "Cayman Islands", "value": "KY" },
                { "name": "Central African Republic", "value": "CF" },
                { "name": "Chad", "value": "TD" },
                { "name": "Chile", "value": "CL" },
                { "name": "China", "value": "CN" },
                { "name": "Christmas Island", "value": "CX" },
                { "name": "Cocos (Keeling) Islands", "value": "CC" },
                { "name": "Colombia", "value": "CO" },
                { "name": "Comoros", "value": "KM" },
                { "name": "Congo", "value": "CG" },
                { "name": "Congo, The Democratic Republic of the", "value": "CD" },
                { "name": "Cook Islands", "value": "CK" },
                { "name": "Costa Rica", "value": "CR" },
                { "name": "Cote D\"Ivoire", "value": "CI" },
                { "name": "Croatia", "value": "HR" },
                { "name": "Cuba", "value": "CU" },
                { "name": "Cyprus", "value": "CY" },
                { "name": "Czech Republic", "value": "CZ" },
                { "name": "Denmark", "value": "DK" },
                { "name": "Djibouti", "value": "DJ" },
                { "name": "Dominica", "value": "DM" },
                { "name": "Dominican Republic", "value": "DO" },
                { "name": "Ecuador", "value": "EC" },
                { "name": "Egypt", "value": "EG" },
                { "name": "El Salvador", "value": "SV" },
                { "name": "Equatorial Guinea", "value": "GQ" },
                { "name": "Eritrea", "value": "ER" },
                { "name": "Estonia", "value": "EE" },
                { "name": "Ethiopia", "value": "ET" },
                { "name": "Falkland Islands (Malvinas)", "value": "FK" },
                { "name": "Faroe Islands", "value": "FO" },
                { "name": "Fiji", "value": "FJ" },
                { "name": "Finland", "value": "FI" },
                { "name": "France", "value": "FR" },
                { "name": "French Guiana", "value": "GF" },
                { "name": "French Polynesia", "value": "PF" },
                { "name": "French Southern Territories", "value": "TF" },
                { "name": "Gabon", "value": "GA" },
                { "name": "Gambia", "value": "GM" },
                { "name": "Georgia", "value": "GE" },
                { "name": "Germany", "value": "DE" },
                { "name": "Ghana", "value": "GH" },
                { "name": "Gibraltar", "value": "GI" },
                { "name": "Greece", "value": "GR" },
                { "name": "Greenland", "value": "GL" },
                { "name": "Grenada", "value": "GD" },
                { "name": "Guadeloupe", "value": "GP" },
                { "name": "Guam", "value": "GU" },
                { "name": "Guatemala", "value": "GT" },
                { "name": "Guernsey", "value": "GG" },
                { "name": "Guinea", "value": "GN" },
                { "name": "Guinea-Bissau", "value": "GW" },
                { "name": "Guyana", "value": "GY" },
                { "name": "Haiti", "value": "HT" },
                { "name": "Heard Island and Mcdonald Islands", "value": "HM" },
                { "name": "Holy See (Vatican City State)", "value": "VA" },
                { "name": "Honduras", "value": "HN" },
                { "name": "Hong Kong", "value": "HK" },
                { "name": "Hungary", "value": "HU" },
                { "name": "Iceland", "value": "IS" },
                { "name": "India", "value": "IN" },
                { "name": "Indonesia", "value": "ID" },
                { "name": "Iran, Islamic Republic Of", "value": "IR" },
                { "name": "Iraq", "value": "IQ" },
                { "name": "Ireland", "value": "IE" },
                { "name": "Isle of Man", "value": "IM" },
                { "name": "Israel", "value": "IL" },
                { "name": "Italy", "value": "IT" },
                { "name": "Jamaica", "value": "JM" },
                { "name": "Japan", "value": "JP" },
                { "name": "Jersey", "value": "JE" },
                { "name": "Jordan", "value": "JO" },
                { "name": "Kazakhstan", "value": "KZ" },
                { "name": "Kenya", "value": "KE" },
                { "name": "Kiribati", "value": "KI" },
                { "name": "Korea, Democratic People\"S Republic of", "value": "KP" },
                { "name": "Korea, Republic of", "value": "KR" },
                { "name": "Kuwait", "value": "KW" },
                { "name": "Kyrgyzstan", "value": "KG" },
                { "name": "Lao People\"S Democratic Republic", "value": "LA" },
                { "name": "Latvia", "value": "LV" },
                { "name": "Lebanon", "value": "LB" },
                { "name": "Lesotho", "value": "LS" },
                { "name": "Liberia", "value": "LR" },
                { "name": "Libyan Arab Jamahiriya", "value": "LY" },
                { "name": "Liechtenstein", "value": "LI" },
                { "name": "Lithuania", "value": "LT" },
                { "name": "Luxembourg", "value": "LU" },
                { "name": "Macao", "value": "MO" },
                { "name": "Macedonia, The Former Yugoslav Republic of", "value": "MK" },
                { "name": "Madagascar", "value": "MG" },
                { "name": "Malawi", "value": "MW" },
                { "name": "Malaysia", "value": "MY" },
                { "name": "Maldives", "value": "MV" },
                { "name": "Mali", "value": "ML" },
                { "name": "Malta", "value": "MT" },
                { "name": "Marshall Islands", "value": "MH" },
                { "name": "Martinique", "value": "MQ" },
                { "name": "Mauritania", "value": "MR" },
                { "name": "Mauritius", "value": "MU" },
                { "name": "Mayotte", "value": "YT" },
                { "name": "Mexico", "value": "MX" },
                { "name": "Micronesia, Federated States of", "value": "FM" },
                { "name": "Moldova, Republic of", "value": "MD" },
                { "name": "Monaco", "value": "MC" },
                { "name": "Mongolia", "value": "MN" },
                { "name": "Montserrat", "value": "MS" },
                { "name": "Morocco", "value": "MA" },
                { "name": "Mozambique", "value": "MZ" },
                { "name": "Myanmar", "value": "MM" },
                { "name": "Namibia", "value": "NA" },
                { "name": "Nauru", "value": "NR" },
                { "name": "Nepal", "value": "NP" },
                { "name": "Netherlands", "value": "NL" },
                { "name": "Netherlands Antilles", "value": "AN" },
                { "name": "New Caledonia", "value": "NC" },
                { "name": "New Zealand", "value": "NZ" },
                { "name": "Nicaragua", "value": "NI" },
                { "name": "Niger", "value": "NE" },
                { "name": "Nigeria", "value": "NG" },
                { "name": "Niue", "value": "NU" },
                { "name": "Norfolk Island", "value": "NF" },
                { "name": "Northern Mariana Islands", "value": "MP" },
                { "name": "Norway", "value": "NO" },
                { "name": "Oman", "value": "OM" },
                { "name": "Pakistan", "value": "PK" },
                { "name": "Palau", "value": "PW" },
                { "name": "Palestinian Territory, Occupied", "value": "PS" },
                { "name": "Panama", "value": "PA" },
                { "name": "Papua New Guinea", "value": "PG" },
                { "name": "Paraguay", "value": "PY" },
                { "name": "Peru", "value": "PE" },
                { "name": "Philippines", "value": "PH" },
                { "name": "Pitcairn", "value": "PN" },
                { "name": "Poland", "value": "PL" },
                { "name": "Portugal", "value": "PT" },
                { "name": "Puerto Rico", "value": "PR" },
                { "name": "Qatar", "value": "QA" },
                { "name": "Reunion", "value": "RE" },
                { "name": "Romania", "value": "RO" },
                { "name": "Russian Federation", "value": "RU" },
                { "name": "RWANDA", "value": "RW" },
                { "name": "Saint Helena", "value": "SH" },
                { "name": "Saint Kitts and Nevis", "value": "KN" },
                { "name": "Saint Lucia", "value": "LC" },
                { "name": "Saint Pierre and Miquelon", "value": "PM" },
                { "name": "Saint Vincent and the Grenadines", "value": "VC" },
                { "name": "Samoa", "value": "WS" },
                { "name": "San Marino", "value": "SM" },
                { "name": "Sao Tome and Principe", "value": "ST" },
                { "name": "Saudi Arabia", "value": "SA" },
                { "name": "Senegal", "value": "SN" },
                { "name": "Serbia and Montenegro", "value": "CS" },
                { "name": "Seychelles", "value": "SC" },
                { "name": "Sierra Leone", "value": "SL" },
                { "name": "Singapore", "value": "SG" },
                { "name": "Slovakia", "value": "SK" },
                { "name": "Slovenia", "value": "SI" },
                { "name": "Solomon Islands", "value": "SB" },
                { "name": "Somalia", "value": "SO" },
                { "name": "South Africa", "value": "ZA" },
                { "name": "South Georgia and the South Sandwich Islands", "value": "GS" },
                { "name": "Spain", "value": "ES" },
                { "name": "Sri Lanka", "value": "LK" },
                { "name": "Sudan", "value": "SD" },
                { "name": "Suriname", "value": "SR" },
                { "name": "Svalbard and Jan Mayen", "value": "SJ" },
                { "name": "Swaziland", "value": "SZ" },
                { "name": "Sweden", "value": "SE" },
                { "name": "Switzerland", "value": "CH" },
                { "name": "Syrian Arab Republic", "value": "SY" },
                { "name": "Taiwan, Province of China", "value": "TW" },
                { "name": "Tajikistan", "value": "TJ" },
                { "name": "Tanzania, United Republic of", "value": "TZ" },
                { "name": "Thailand", "value": "TH" },
                { "name": "Timor-Leste", "value": "TL" },
                { "name": "Togo", "value": "TG" },
                { "name": "Tokelau", "value": "TK" },
                { "name": "Tonga", "value": "TO" },
                { "name": "Trinidad and Tobago", "value": "TT" },
                { "name": "Tunisia", "value": "TN" },
                { "name": "Turkey", "value": "TR" },
                { "name": "Turkmenistan", "value": "TM" },
                { "name": "Turks and Caicos Islands", "value": "TC" },
                { "name": "Tuvalu", "value": "TV" },
                { "name": "Uganda", "value": "UG" },
                { "name": "Ukraine", "value": "UA" },
                { "name": "United Arab Emirates", "value": "AE" },
                { "name": "United Kingdom", "value": "GB" },
                { "name": "United States", "value": "US" },
                { "name": "United States Minor Outlying Islands", "value": "UM" },
                { "name": "Uruguay", "value": "UY" },
                { "name": "Uzbekistan", "value": "UZ" },
                { "name": "Vanuatu", "value": "VU" },
                { "name": "Venezuela", "value": "VE" },
                { "name": "Viet Nam", "value": "VN" },
                { "name": "Virgin Islands, British", "value": "VG" },
                { "name": "Virgin Islands, U.S.", "value": "VI" },
                { "name": "Wallis and Futuna", "value": "WF" },
                { "name": "Western Sahara", "value": "EH" },
                { "name": "Yemen", "value": "YE" },
                { "name": "Zambia", "value": "ZM" },
                { "name": "Zimbabwe", "value": "ZW" }
            ];
            return countriesJson;
        };
        Tools.getModalWidth = function () {
            var modalWidth = $(window).width() - 40;
            var maxWidth = 1300;
            var minWidth = 700;
            if (modalWidth > maxWidth) {
                modalWidth = maxWidth;
            }
            else if (modalWidth < minWidth) {
                modalWidth = minWidth;
            }
            return modalWidth;
        };
        Tools.updateModelValidation = function (model, validations, isRoot) {
            if (isRoot === void 0) { isRoot = true; }
            var m = $.isFunction(model) ? model() : model;
            for (var propretyName in validations) {
                if (m.hasOwnProperty(propretyName)) {
                    m[propretyName].extend(validations[propretyName]);
                }
            }
            if (isRoot) {
                ko.validatedObservable(m);
            }
        };
        Tools.autoSyncInterval = 60 * 1000;
        Tools.loader = '<div class="modal-form content-loader"><div class="spinner-large"><div class="spinner"></div></div></div>';
        return Tools;
    }());
    return Tools;
});
//# sourceMappingURL=tools.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/tools.js
// module id = 2
// module chunks = 2